module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Heavy.7616f9b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-Heavy.otf
// module id = Qt9e
// module chunks = 1